export enum ModalType {
  GROUP_OWNER_INACTIVE,
  FULL_GROUP,
  ALREADY_IN_GROUP,
}

export interface GroupPlanModalProps {
  showModal: boolean
  onHideModal: () => void
  modalType: ModalType
}
